export default __webpack_public_path__ + "static/media/Dylan-Best-Picture.00d0244d.jpg";